import mobileMenu from "./modules/MobileMenu";
import GoogleMapsAPI from "../gutenberg/blocks/location-finder/modules/GoogleMapsAPI";
// import FormControl from "./modules/FormControl";

const topBarHeight = 133;

/* -------------------------------------------------------------------------- */
/*                              Init Mobile Menu                              */
/* -------------------------------------------------------------------------- */
mobileMenu({
  selector: ".mobile-menu",
  block: "mobile-menu",
  toggleActiveClass: "header__hamburger--open",
});


/* -------------------------------------------------------------------------- */
/*                         Init Follower CTA Listener                         */
/* -------------------------------------------------------------------------- */
const followingCTA = document.querySelector(".following-cta");

if (followingCTA) {
  window.addEventListener("scroll", () => {
    // window scroll listener
    if (window.scrollY >= topBarHeight) {
      followingCTA.classList.add("following-cta--show");
    } else {
      followingCTA.classList.remove("following-cta--show");
    }
  });
}

